module.exports = __webpack_public_path__ + "static/fonts/materialdesignicons-webfont.79077fa.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mdi/font/fonts/materialdesignicons-webfont.woff2?v=2.7.94
// module id = l9Vi
// module chunks = 0